<template>
  <div class="tabs-card">
    <div class="card-nav-tabs">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <div class="nav nav-tabs">
            <button 
              v-for="tab in tabs"
              class="nav-link btn-tab" 
              :class="{ 'active': activeTab === tab.id }"
              :key="tab.id"
              @click="emitTabClick(tab)"
            >{{ tab.label }}</button>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="tab-content">
            <div 
              class="tab-pane active"
              :key="activeTab"
            >
              <slot :name="activeTab"></slot>
            </div>
          </div>
        </div>  
      </div>    
    </div>       
  </div>
</template>
<script>
export default {
  props: ['tabs', 'active-tab'],

  methods: {
    emitTabClick(tab) {
      this.$emit('tabClick', tab.id)
    }
  }
}
</script>
<style lang="scss">
  .tabs-card {
    .nav-tabs {
      border-bottom: none;

      .nav-link {
        border-bottom-color: #f3f3f3;
        box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
        margin-right: 3px;
        opacity: 0.6;

        &.active {
          border-color: transparent;
          opacity: 1;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .card {
      border-radius: 0 6px 6px 6px;
    }
  }
</style>